module.exports = __webpack_public_path__ + "static/media/exit-grey.f6271737.svg";